var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c("button", { on: { click: _vm.decrease } }, [_vm._v("-")]),
    _vm._v(" "),
    _c("span", { staticClass: "stakeInput" }, [
      _c("input", {
        ref: "input",
        domProps: { value: _vm.value },
        on: {
          input: function($event) {
            return _vm.updateValue($event.target.value)
          },
          focus: _vm.selectAll,
          blur: _vm.formatValue
        }
      })
    ]),
    _vm._v(" "),
    _c("button", { on: { click: _vm.increase } }, [_vm._v("+")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-945f04c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-945f04c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslip/stakeInput.vue
// module id = null
// module chunks = 